<template>
<div>
<DataTable 
:value="items" 
:lazy="false" 
:paginator="true" 
class="p-datatable-suppliers" 
:rows="rows"
:page="page+1"
:first="first"
:totalRecords="totalRecords"
dataKey="id" 
:rowHover="true" 
v-model:selection="selectedSuppliers" 
v-model:filters="filters" 
filterDisplay="menu" 
:loading="loading"
@page="onPage($event)" 
@sort="onSort($event)" 
@filter="onFilter($event)"
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
:rowsPerPageOptions="[5,10,25,50,100]"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:globalFilterFields="['name','suppliercode','brand.name','flow_status']" 
responsiveLayout="scroll"
>
            <template #header>
              <div class="grid">
                

                <div class="col-12 md:col-8  pt-1">

                        

                    </div>

                    
                   

              </div>
                 
            </template>
            <template #empty>
                No suppliers found.
            </template>
            <template #loading>
                <div class="loading_overlay">
                    <ProgressSpinner style="width:50px;height:50px" strokeWidth="4" color="deneme" />
                Loading  data. Please wait.
            </div>
            </template>
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
            <Column field="name" :header="$store.state.languages.lang_phrases.isim" sortable style="min-width: 15rem;max-width:20rem">
                <template #body="{data}">
                    <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.id}}">{{data.name}}</router-link>
                </template>
               
            </Column>
            <Column field="suppliercode" :header="$store.state.languages.lang_phrases.tedarikci_kodu" sortable style="min-width: 14rem">
                <template #body="{data}">
                    {{data.suppliercode}}
                </template>
                    <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by suppliercode"/>
            </Column>

            
            <Column field="brand" filterField="brand.name" v-if="show_brand" :header="$store.state.languages.lang_phrases.marka" sortable filterMatchMode="contains" style="min-width: 14rem">
                 <template #body="{data}">
                    {{data.brand.name}}
                </template>
               
            </Column>

            <Column field="projects" v-if="show_projects" :header="$store.state.languages.lang_phrases.projeler"  filterMatchMode="contains" style="min-width: 14rem">
                 <template #body="{data}">
                    <TableTag :data="data.projectsuppliers" type="project" v-if="data.projectsuppliers.length"></TableTag>
                    
                </template>
               
            </Column>

            <Column field="flows" v-if="show_flows" :header="$store.state.languages.lang_phrases.akislar"  filterMatchMode="contains" style="min-width: 14rem">
                 <template #body="{data}">
                    <TableTag :data="data.flows" type="flow"  v-if="data.flows.length"></TableTag>
                </template>

               
            </Column>




          

            <Column field="flow_status"  :header="$store.state.languages.lang_phrases.durum"  :filterMenuStyle="{'width':'14rem'}"  v-if="show_flow_status" style="min-width:12rem">
                    <template #body="{data}">
                    <template v-if="data.flow_status=='created'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.olusturuldu" 
                            :style="'background-color:#352f8d'"
                            />
                    </template>
                    <template v-if="data.flow_status=='viewed'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.goruntulendi" 
                            :style="'background-color:#7e2f8d'"
                            />
                    </template>
                    <template v-if="data.flow_status=='started'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.baslandi" 
                            :style="'background-color:#dd4b39'"
                            />
                    </template>
                    <template v-if="data.flow_status=='finished'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.tamamlandi0" 
                            :style="'background-color:#4dc247'"
                            />
                    </template>
                    <template v-if="data.flow_status=='under_review'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.degerlendirmede" 
                            :style="'background-color:#ff6600'"
                            />
                    </template>
                    <template v-if="data.flow_status=='canceled'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.iptal_edildi" 
                            :style="'background-color:#a82400'"
                            />
                    </template>
                    <template v-if="data.flow_status=='correction_requested'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede" 
                            :style="'background-color:#3b82f6'"
                            />
                    </template>
                </template>


                   

                    <template #filter="{filterModel,filterCallback}">
                        <Dropdown v-model="filterModel.value" @change="filterCallback()" :options="statuses" placeholder="Hepsi" class="p-column-filter" :showClear="true">
                            <template #value="slotProps">
                                <span :class="'customer-badge status-' + slotProps.value" v-if="slotProps.value">{{slotProps.value.name}}</span>
                                <span v-else>{{slotProps.placeholder}}</span>
                            </template>
                            <template #option="slotProps">
                                <span :class="'customer-badge status-' + slotProps.option">{{slotProps.option.name}}</span>
                            </template>
                        </Dropdown>
                    </template>

                    
                </Column>


           


          
           
            
            <Column field="date" :header="$store.state.languages.lang_phrases.eklenme_tarihi" sortable dataType="date" style="min-width: 8rem">
                <template #body="{data}">
                    {{ $filters.momentFormat( data.created_at," Do MM YYYY hh:mm")}}
                </template>
                    <Calendar v-model="filterModel.value" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" />
            </Column>
            
            
            
            <Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
                <template #body="{data}">
                   <Button type="button"  icon="pi pi-ellipsis-h" @click="toggle" aria-haspopup="true" :aria-controls="'overlay_menu'+data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />
          <Menu :id="'overlay_menu'+data.id" ref="menu" :model="menuitems" :popup="true">
           <template #item="{item}">  
          <a class="p-menuitem-link" role="menuitem" @click="item.command(item.argument,{id:data.id})">
          <span :class="'p-menuitem-icon '+item.icon"></span>
          <span class="p-menuitem-text">{{item.label}}</span>
          <span class="p-ink"></span></a>
          </template>
          </Menu>
                </template>
            </Column>
        </DataTable>

</div>
</template>

<script>
import {FilterMatchMode,FilterOperator} from 'primevue/api';
import SuppliersTableProjectsModal from "./SuppliersTableProjectsModal"
import SuppliersTableFlowsModal from "./SuppliersTableFlowsModal"
import SuppliersTableCustomAttributesModal from "./SuppliersTableCustomAttributesModal"


import TableTag from "./TableTag"


export default {

  name: '"ContentTableFilterable"',
  components:{SuppliersTableProjectsModal,SuppliersTableFlowsModal,TableTag,SuppliersTableCustomAttributesModal},
  props:["items","show_brand","show_projects","show_flows","display_page","show_flow_status","loading","totalRecords","rows","page","customattributes"],
  data () {
    return {
      selectedSuppliers:[],
        first:0,
        intervalobj:null,
      selectedaction:"placeholder",
        selected_customattribute:null,
        customattribute_query:{
            customattribute_id:null,
            customattribute_type:null,
            numerical_val:null,
            numerical_operation:null,
            text_val:null,
            text_operation:null,
        },
        numerical_operations:[
        {name:"değerine eşitse",code:"equal_to"},
        {name:"değerine eşit değilse",code:"not_equal_to"},
        {name:"değerinden büyükse",code:"greater_than"},
        {name:"değerinden küçükse",code:"less_than"},
        {name:"değer girildiyse",code:"input_filled"},
        ],
        text_operations:[
        {name:"Terimini içeriyorsa",code:"includes"},
        {name:"Terimini içermiyorsa",code:"does_not_include"},
        {name:"değer girildiyse",code:"input_filled"},
        ],
        booleanoptions:[
        {name:"Açık",code:1},
        {name:"Kapalı",code:0},
        ],
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
        'suppliercode': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
        'date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},
        'flow_status': {value: null, matchMode: FilterMatchMode.EQUALS},
      },
      menuitems: [
        {
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                argument:"Supplier",
                command: (argument,id) => {
                  console.log(argument)
                  console.log(id)
                     this.gotoPage(argument,id)
                  }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                argument:"suppliers",
                command: (argument,id) => {
                     this.deleteItem(argument,id)
                  }
            },

      ]
    }
  },
  computed:{
    statuses()
    {
        let arr = [
        {name:this.$store.state.languages.lang_phrases.olusturuldu,id:"created"},
        {name:this.$store.state.languages.lang_phrases.goruntulendi,id:"viewed"},
        {name:this.$store.state.languages.lang_phrases.baslandi,id:"started"},
        {name:this.$store.state.languages.lang_phrases.tamamlandi0,id:"finished"},
        {name:this.$store.state.languages.lang_phrases.degerlendirmede,id:"under_review"},
        {name:this.$store.state.languages.lang_phrases.iptal_edildi,id:"canceled"},
        {name:this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede,id:"correction_requested"},
        ]
        return  arr
    },
    selectedactions()
    {
     if(this.display_page=="brand")
        {
            return [
                    {
                        name:"Seçili öğeleri...",
                        action:"placeholder",
                        disabled:true
                    },
                    {
                        name:"Projeye Ekle",
                        action:"add_to_project"
                    },
                    {
                        name:"Akışa Ekle",
                        action:"add_to_flow"
                    },                    
                    {
                        name:"Özel Nitelik Güncelle",
                        action:"update_custom_attribute"
                    },
                    {
                        name:"Sil",
                        action:"delete"
                    }
                    ]
        }

        if(this.display_page=="project")
        {
            return [
                    {
                        name:"Seçili öğeleri...",
                        action:"placeholder",
                        disabled:true
                    },
                    {
                        name:"Projeye Ekle",
                        action:"add_to_project"
                    },
                    {
                        name:"Projeden Çıkar",
                        action:"remove_from_project"
                    },
                    {
                        name:"Akışa Ekle",
                        action:"add_to_flow"
                    },                 
                    {
                        name:"Özel Nitelik Güncelle",
                        action:"update_custom_attribute"
                    },
                    {
                        name:"Sil",
                        action:"delete"
                    }
                    ]
        }

        if(this.display_page=="flow")
        {
            return [
                    {
                        name:"Seçili öğeleri...",
                        action:"placeholder",
                        disabled:true
                    },
                    {
                        name:"Projeye Ekle",
                        action:"add_to_project"
                    },
                    {
                        name:"Akışa Ekle",
                        action:"add_to_flow"
                    },
                    {
                        name:"Akıştan Çıkar",
                        action:"remove_from_flow"
                    },                 
                    {
                        name:"Özel Nitelik Güncelle",
                        action:"update_custom_attribute"
                    },
                    {
                        name:"Sil",
                        action:"delete"
                    }
                    ]
        }

        if(this.display_page=="suppliers")
        {
            return [
                    {
                        name:"Seçili öğeleri...",
                        action:"placeholder",
                        disabled:true
                    },
                    {
                        name:"Sil",
                        action:"delete"
                    }
                    ]
        }

    },
  },
  methods:{
    searchSupplier()
    {
        
        clearInterval(this.intervalobj);
        this.intervalobj = setInterval(()=>{
            this.$emit("searchSupplier",this.filters["global"].value)
            clearInterval(this.intervalobj);
        },1000)
    },
    onPage(event)
    {
        console.log("onPage")
        this.$emit("onPage",{event:event,customattribute_query:this.customattribute_query})
    },
    onSort(event)
    {
        
        this.$emit("onSort",event)
    },
    onFilter(event)
    {
        //console.log("filter")
        this.$emit("filter",event)
    },
    selectCustomAttribute()
    {
        console.log(this.selected_customattribute) 
        this.customattribute_query = {            
            customattribute_id:null,
            customattribute_type:null,
            numerical_val:null,
            numerical_operation:null,
            text_val:null,
            text_operation:null,
        }
    },
    clearCustomAttributeSelection()
    {
        this.selected_customattribute = null
        this.customattribute_query = {
            customattribute_id:null,
            customattribute_type:null,
            numerical_val:null,
            numerical_operation:null,
            text_val:null,
            text_operation:null,
        }
        this.$emit("customattributeFiltered",this.customattribute_query)
    },
    customAttributeQuerySet()
    {
        this.customattribute_query.customattribute_id = this.selected_customattribute.id
        this.customattribute_query.customattribute_type = this.selected_customattribute.type
        this.$emit("customattributeFiltered",this.customattribute_query)
    },
    selectAction()
    {
      //console.log(this.selectedaction)
        console.log(this.selectedSuppliers)
        if(this.selectedaction.action=="add_to_project")
        {
            this.$refs.projects.showModal()
        }
        if(this.selectedaction.action=="add_to_flow")
        {
            this.$refs.flows.showModal()
        }

        if(this.selectedaction.action=="remove_from_flow")
        {
            this.$refs.flows.showModal()
        }

        if(this.selectedaction.action=="update_custom_attribute")
        {
            this.$refs.customattributes.showModal()
        }
        if(this.selectedaction.action=="delete")
        {
            this.$refs.flows.showModal()
        }
        //this.selectedaction = "placeholder"

    },
    closemodal()
    {
        this.selectedaction = "placeholder"
    },
    toggle(event) {
        this.$refs.menu.toggle(event);
    },
    gotoSupplier(id)
    {
        this.$router.push({ name: "Supplier", params:{ id:id} }) 
    }
  }
}
</script>

<style lang="scss" scoped>
.loading_overlay
{
    background-color:rgba(53, 47, 141, 0.3);
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#fff;
    flex-direction:column;

}
::v-deep(.p-paginator) {
    .p-paginator-current {
        margin-left: auto;
    }
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

::v-deep(.p-datepicker) {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

::v-deep(.p-datatable.p-datatable-suppliers) {
    .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead > tr > th {
        text-align: left;
    }

    .p-datatable-tbody > tr > td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}
</style>